<template>
  <div>
    <el-dialog
      :visible="value"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      class="select-mater"
      width="80%"
      top="60px"
      @close="handleBeforCloseImgTable"
    >
      <div slot="title" class="select-mater-title">
        <span>选择素材</span>

      </div>
      <div class="dialog-search-header">
        <div>
          <el-form
            :model="searchForm"
            ref="searchForm"
            :inline="true"
            label-width="117px"
            label-position="left"
            size="small"
          >
            <el-form-item>
              <el-input
                placeholder="输入素材ID或名称搜索"
                v-model="searchForm.searchParam"
                v-noEmoji
                clearable
                class="form-input"
                @change="handleOpenDialog"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="timeList"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="getUploadTime"
                class="form-picker"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.checkStatus"
                clearable
                placeholder="请选择素材状态"
                class="form-select"
                @change="handleOpenDialog"
              >
                <el-option
                  v-for="item in checkStatausOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="multiple !== true">
          <span
            style="font-size: 24px;cursor: pointer"
            @click="isShowGrid = !isShowGrid"
          >
            <i :class="isShowGrid ? 'el-icon-s-fold' : 'el-icon-s-grid '"></i>
          </span>
        </div>
      </div>
      <Table
        ref="pageTable"
        :props="table.props"
        :header="table.header"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
        v-if="!isShowGrid"
        v-loading="tableLoading"
      />
      <template v-if="isShowGrid">
        <template v-if="gridTable.data.length === 0 && !cardLoading"
          ><div class="img-list-none">暂无数据</div></template
        >
        <template v-else>
          <CardList
            class="img-list"
            :data="gridTable.data"
            :selected="gridTable.selected"
            :selection-type="gridTable.selectionType"
            v-loading="cardLoading"
          >
            <div class="img-item" slot="row" slot-scope="{ row: item }">
              <div class="img-item-box">
                <img
                  referrerpolicy="no-referrer"
                  :key="item.mediaIcon"
                  :src="item.mediaIcon"
                />
              </div>
              <div class="img-title">{{ item.mediaName }}</div>
              <div class="img-detail">
                <el-button
                  @click="handleRowSelectionChange(item)"
                  :disabled="existMediaId.indexOf(item.mediaId) > -1"
                  >选择</el-button
                >
              </div>
              <div class="img-info" style="color: #FF8B00">
                <span>
                  <i
                    style="font-size: 12px;"
                    v-if="item.mediaClassId === 1"
                    class="el-icon-picture"
                  ></i>
                  <i
                    style="font-size: 12px;"
                    v-else
                    class="el-icon-video-camera-solid"
                  ></i>
                </span>
                <span class="img-status">
                  {{ $consts.materialStatisText[item.checkStatus] }}
                </span>
              </div>
            </div>
          </CardList>
        </template>
      </template>
      <el-pagination
        :total="totalCount"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
      ></el-pagination>
      <div v-if="multiple" slot="footer">
        <el-button type="plain" @click="$emit('go-back')">取消</el-button>
        <el-button type="primary" @click="saveMultiSelect">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Table, CardList } from '@ccprivate/admin-toolkit'
import { debounce } from 'lodash'
export default {
  components: {
    Table,
    CardList
  },
  props: ['value', 'mediaList', 'orderScheduleForm', 'mediaQuery', 'multiple'],
  data() {
    return {
      tableLoading: false,
      cardLoading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        order: 'desc',
        sort: 'mediaId',
        searchParam: undefined,
        searchParamType: 2,
        checkStatus: undefined,
        spaceId: undefined,
        partnerId: undefined,
        beginTime: undefined,
        endTime: undefined
      },
      search: '',
      timeList: [],
      checkStatausOptions: [
        {
          label: '草稿',
          value: 0
        },
        {
          label: '审核中',
          value: 1
        },
        {
          label: '测试中',
          value: 2
        },
        {
          label: '已测试',
          value: 4
        }
      ],
      isShowGrid: false,
      existMediaId: [],
      istableSelectDisable: true,
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      table: {
        props: {
          height: 380,
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '缩略图',
            align: 'left',
            prop: 'mediaIcon',
            'min-width': 80,
            isShow: true,
            render: (h, { row }) => {
              return h('el-image', {
                attrs: {
                  src: row.mediaIcon,
                  fit: 'contain'
                },
                style: {
                  width: '100px',
                  height: '59px'
                }
              })
            }
          },
          {
            label: '素材ID',
            align: 'left',
            prop: 'mediaId',
            'min-width': 80,
            'show-overflow-tooltip': true
          },
          {
            label: '素材名称',
            align: 'left',
            prop: 'mediaName',
            'min-width': 160,
            'show-overflow-tooltip': true
          },
          {
            label: '状态',
            align: 'left',
            prop: 'checkStatus',
            'min-width': 80,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.$consts.materialStatisText[row.checkStatus]
            }
          },
          {
            label: '类型',
            align: 'left',
            prop: 'mediaClassId',
            'min-width': 80,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adMediaClass ? row.adMediaClass.mediaClassName : ''
            }
          }
        ],
        data: [],
        selectionType: this.multiple ? 'multiple' : undefined,
        selected: []
      },
      operateCol: {
        label: '操作栏',
        'min-width': 100,
        align: 'left',
        render: (h, { row }) => {
          const disabled = this.existMediaId.indexOf(row.mediaId) > -1
          return h('div', [
            h(
              'el-button',
              {
                props: {
                  type: 'text',
                  disabled
                },
                on: {
                  click: event => {
                    event.stopPropagation()
                    this.handleRowSelectionChange(row)
                  }
                }
              },
              '选择'
            )
          ])
        }
      },
      selected: [],
      selectedRow: [],
      gridTable: {
        props: {},
        data: [],
        selected: undefined
      },
      timer: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue) {
        this.handleOpenDialog()
      }
    }
  },
  methods: {
    /** 素材库方法 */
    handleOpenDialog() {
      this.istableSelectDisable = true
      this.existMediaId = this.mediaList.reduce((result, item) => {
        if (item.mediaId) {
          result.push(item.mediaId)
        }
        return result
      }, [])
      // 多选
      if (this.multiple) {
        this.selected = this.mediaList.map(item => item.mediaId)
        this.selectedRow = this.cloneDeep(this.mediaList)
      }

      if (this.isShowGrid) {
        this.cardLoading = true
      } else {
        this.tableLoading = true
      }
      this.searchForm.pageNo = 1
      this.fetchData()
      this.fetchDataDebounced = debounce(this.handleOpenDialog, 500)
    },
    fetchData() {
      this.filter = this.searchForm
      this.filter.spaceId = this.orderScheduleForm.spaceId
      this.filter.partnerId = this.orderScheduleForm.partnerId
      this.filter.checkStatusArray = this.mediaQuery.checkStatusArray
      this.filter.width = this.mediaQuery.width
      this.filter.height = this.mediaQuery.height
      this.filter.mediaClassId = this.mediaQuery.mediaClassId
      this.$service.getMediaPageList(this.filter).then(data => {
        this.totalCount = data.total
        this.gridTable.data = data.rows
        this.table.data = data.rows
        this.cardLoading = false
        this.tableLoading = false
        this.updateTableSelected()
        this.$refs.pageTable.$refs.table.doLayout()
      }).catch(() => {
        this.cardLoading = false
        this.tableLoading = false
      })
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.searchForm.pageNo = val
      if (this.isShowGrid) {
        this.cardLoading = true
      } else {
        this.tableLoading = true
      }
      this.fetchData()
    },
    // 关闭弹窗的的事件
    handleBeforCloseImgTable() {
      this.search = ''
      this.currentPage = 1
      this.pageSize = 10
      this.$emit('input', false)
    },
    getUploadTime() {
      if (this.timeList) {
        this.searchForm.beginTime = this.$moment(this.timeList[0]).format(
          'YYYY-MM-DD 00:00:00'
        )
        this.searchForm.endTime = this.$moment(this.timeList[1]).format(
          'YYYY-MM-DD 23:59:59'
        )
      } else {
        this.searchForm.beginTime = ''
        this.searchForm.endTime = ''
      }
      this.handleOpenDialog()
    },
    // 选中素材，需要
    handleRowSelectionChange(row) {
      // 放到父组件去执行
      this.table.selected = []
      this.gridTable.selected = []
      this.$emit('selected-media', row)
    },
    handleRowSelectionAdd(row) {
      this.selected.push(row.mediaId)
      this.selectedRow.push(row)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(row) {
      this.selected = this.selected.filter((item) => {
        return item !== row.mediaId
      })
      this.selectedRow = this.selectedRow.filter((item) => {
        return item.mediaId !== row.mediaId
      })
      this.updateTableSelected()
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        const mediaIds = this.table.data
          .filter((item, index) => this.table.selected.includes(index))
          .map(item => item.mediaId)
        this.selected = this.selected.filter(key => !mediaIds.includes(key))
        this.selectedRow = this.selectedRow.filter(row => !mediaIds.includes(row.mediaId))
        this.table.selected = []
      }
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.mediaId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    saveMultiSelect() {
      this.$emit('selected-media', this.selectedRow)
    }
  },
  created() {
    const hasOperateCol = this.table.header.find(item => item.label === '操作栏')
    if (!this.multiple && !hasOperateCol) {
      this.table.header.push(this.operateCol)
    }
  }
}
</script>
<style lang="stylus" scoped>
.select-mater >>> .el-dialog__body {
  padding: 16px 40px
}
.dialog-title {
  display: flex;
  line-height: 32px;
}

.dialog-option {
  margin-left: auto;
}

.dialog-search-header {
  display: flex;
  flex-direction: row;
  justify-content space-between
}
/* *素材库选择器样式 */
.img-list-none {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color #909399
}
.img-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  height 392px
}
.img-list
  >>>.el-row
    width 100%
    margin 0 !important

>>>.card-item-wrapper {
  width 19.1%
  margin-right 9px
  margin-bottom 9px
  padding 0px !important
  // margin-right 9px
  height 185px
  background:rgba(255,255,255,1);
  border-radius:2px;
  border:1px solid rgba(233,233,233,1);
}
.img-list>>>.card-item-wrapper:nth-child(5n+5) {
  margin-right 0
}

.img-item {
  .img-item-box {
    height 116px
  }
  img {
    width 100%
    max-height 100%
  }

  .img-detail {
    position: absolute;
    top: 0;
    text-align: center;
    background: rgba(8, 8, 8, 0.5);
    width: 100%;
    display: none;
    height: inherit;
    line-height: 185px;

    .detail-button {
      margin-top: -50px;
      top: 50%;
      position: relative;
    }

    span {
      display: block;
    }
  }

  &:hover {
    .img-detail {
      display: block;
    }
  }

  .img-info {
    font-size 12px
    padding 0px 8px 8px
  }
  .img-title {
    height 40px
    line-height 20px
    padding 8px 8px 0px 8px
    position relative
    text-overflow ellipsis
    overflow hidden
    display: -moz-box
    -moz-line-clamp 2 !important
    -moz-box-orient vertical
    /* autoprefixer: off */
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
  }

  .img-status {
    float: right;
  }

  .img-preview {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    height: 20px;
    color: #444;
    background: #fff;
    padding: 0px 5px;
  }
}
.table-header-button.is-disabled, .table-header-button.is-disabled:hover {
  color: #D8D8D8;
  color: #D8D8D8;
}

.table-header-button {
  color: #666;
  border: none !important;
}
>>>.el-form-item {
  margin-bottom 16px
}
.select-mater-title {
  padding 0
}
>>>.el-dialog__header {
  padding 16px 24px
  border-bottom 1px solid rgba(0,0,0,0.09)
}
.select-mater-title span {
  width:64px;
  height:24px;
  font-size:16px;
  font-weight:500;
  color:rgba(0,0,0,0.85);
  line-height:24px;
}
.form-input ,.form-picker,.form-select {
  width 220px
}
.form-picker {
  margin-left: auto;

  >>>.el-range-editor.el-input__inner {
    width: 220px;
  }

  >>>.el-input__inner {
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
